module.exports = __webpack_public_path__ + "static/media/style.5ffa9d79.less";